import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LoadingState {
  active: boolean;
  text?: string;
  translate?: boolean;
  manual?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private requests = 0;

  private stateSubject = new BehaviorSubject<LoadingState>({
    active: false,
    text: '',
    translate: true,
    manual: false,
  });

  public state$ = this.stateSubject.asObservable();

  showGlobal(): void {
    this.requests++;

    if (this.requests === 1) {
      this.stateSubject.next({
        active: true,
        text: '',
        translate: true,
        manual: false,
      });
    }
  }

  hideGlobal(): void {
    this.requests--;

    if (this.requests <= 0) {
      this.requests = 0;

      const current = this.stateSubject.value;

      if (!current.manual) {
        this.stateSubject.next({
          active: false,
          text: '',
          translate: true,
          manual: false,
        });
      }
    }
  }

  show(text?: string, translate = true): void {
    this.stateSubject.next({
      active: true,
      text,
      translate,
      manual: true,
    });
  }

  hide(): void {
    this.stateSubject.next({
      active: false,
      text: '',
      translate: true,
      manual: false,
    });
  }

  getCurrentState(): LoadingState {
    return this.stateSubject.value;
  }
}
